import { makeStyles } from "@mui/styles";
import theme from "src/theme";

export const useStyles = makeStyles({
    wrapperType: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
    },
    label: {
        fontSize: 20,
        fontWeight: 400,
        lineHeight: "24px",
        color: "#F5F5F5CC",
        [theme.breakpoints.down("xl")]: {
            fontSize: 16,
            lineHeight: "20px",
            fontWeight: 500,
            padding: "0px 3px",
        },
        [theme.breakpoints.down("lg")]: {
            fontSize: 16,
            lineHeight: "20px",
            fontWeight: 500,
            padding: "0",
        },
        [theme.breakpoints.down("md")]: {
            fontSize: 15,
            lineHeight: "17px",
            fontWeight: 500,
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: 12,
            lineHeight: "13px",
            fontWeight: 500,
        },
    },
});
